angular.module('tradersyard').filter('highlight', [
    '$sce',
    '$sanitize',
    function ($sce, $sanitize) {
        return function (input: any, searchHighlight: any) {
            const sanitizedInput = $sanitize(input);
            // Sanitizing highlight text will solve issues with highlighting HTML entities like "&".
            const sanitizedHighlight = $sanitize(searchHighlight);

            if (sanitizedHighlight) {
                const highlightRegex = new RegExp(`"[^"]*"|(("[^"]*"|((${sanitizedHighlight}.*?)).*?))`, 'gi');

                return $sce.trustAsHtml(
                    sanitizedInput.replace(highlightRegex, function (match: string, contents: string) {
                        if (typeof contents == 'undefined') return match;

                        return "<span class='highlight_filter'>" + contents + '</span>';
                    })
                );
            }

            return sanitizedInput;
        };
    },
]);

export {};
